import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("button", {
    class: "button",
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('click')))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}